import type { ActionTree } from 'vuex'
import type { ShortUrlState } from './index'
import type { RootState } from '@/store/modules/types'
import { requestApi } from '@/utils/requestApi'

export const shortUrlActions: ActionTree<ShortUrlState, RootState> = {
  async FETCH_SHORT_URLS({ commit, rootState }, params = {}) {
    try {
      commit('SET_FETCHING_SHORT_URLS', true)

      const { promoterOid } = rootState.authModule.account
      const { taskOid, $top = 300, $orderby = 'target_url asc' } = params

      // Build the filter for taskOid if provided
      let filter = `promoterOid = ${promoterOid}`
      if (taskOid) {
        filter += ` AND taskOid = ${taskOid}`
      }

      const response = await requestApi('fetchShortUrls', {
        params: {
          promoterOid,
          $top,
          $orderby,
          $filter: filter,
        },
      })
      if (response && Array.isArray(response)) {
        commit('SET_SHORT_URLS', response)
        return response
      }
      else {
        commit('SET_SHORT_URLS', [])
        return []
      }
    }
    catch (error) {
      console.error('Failed to fetch short URLs:', error)
      commit('SET_SHORT_URLS', [])
      return []
    }
    finally {
      commit('SET_FETCHING_SHORT_URLS', false)
    }
  },
}
